import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { formatDate, getRelated, typeBadgeClass, typeLabels } from "@/utils/content";

export default function RelatedPanel({ item }: { item: ContentItem }) {
  const related = getRelated(item, 4);

  return (
    <aside className="space-y-6">
      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading font-bold text-sm text-foreground-950 mb-4">内容信息</h3>
        <dl className="space-y-3 text-sm">
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">分类</dt>
            <dd>
              <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${typeBadgeClass[item.type]}`}>
                {typeLabels[item.type]}
              </span>
            </dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="text-foreground-500">发布日期</dt>
            <dd className="text-foreground-800">{formatDate(item.date)}</dd>
          </div>
          {item.chapter !== undefined && (
            <div className="flex items-center justify-between">
              <dt className="text-foreground-500">集数</dt>
              <dd className="text-foreground-800">第 {item.chapter} 集</dd>
            </div>
          )}
          {item.role && (
            <div className="flex items-center justify-between">
              <dt className="text-foreground-500">角色定位</dt>
              <dd className="text-foreground-800">{item.role}</dd>
            </div>
          )}
        </dl>
        {item.tags && item.tags.length > 0 && (
          <div className="mt-4 pt-4 border-t border-background-100">
            <p className="text-xs text-foreground-500 mb-2">标签</p>
            <div className="flex flex-wrap gap-1.5">
              {item.tags.map((tag) => (
                <span key={tag} className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 text-xs">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {related.length > 0 && (
        <div className="bg-background-50 border border-background-200 rounded-lg p-5">
          <h3 className="font-heading font-bold text-sm text-foreground-950 mb-4">
            相关推荐
          </h3>
          <ul className="space-y-4">
            {related.map((rel) => (
              <li key={rel.id}>
                <Link to={`/detail/${rel.id}`} className="group flex items-start gap-3 cursor-pointer">
                  <div className="w-16 h-14 rounded-md overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={rel.cover}
                      alt={rel.title}
                      title={`${rel.title} - 年轻的母亲3`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                      {rel.title}
                    </p>
                    <p className="mt-1 text-xs text-foreground-400">{formatDate(rel.date)}</p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
}